import { render, staticRenderFns } from "./BillboardPreview.vue?vue&type=template&id=8ca992e8&"
import script from "./BillboardPreview.vue?vue&type=script&lang=ts&"
export * from "./BillboardPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports